var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBewerber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375.809,
    height: 387.501,
    viewBox: "0 0 375.809 387.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_9",
    "data-name": "Rechteck 9",
    width: 375.809,
    height: 275.4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_4",
    "data-name": "Rechteck 4",
    width: 375.809,
    height: 25.146,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_18",
    "data-name": "Rechteck 18",
    width: 85.606,
    height: 73.195,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_17",
    "data-name": "Rechteck 17",
    width: 85.606,
    height: 73.194,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_38",
    "data-name": "Rechteck 38",
    width: 119.939,
    height: 151.163,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_27",
    "data-name": "Rechteck 27",
    width: 57.291,
    height: 88.683,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_20",
    "data-name": "Rechteck 20",
    width: 26.201,
    height: 26.202,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_22",
    "data-name": "Rechteck 22",
    width: 26.201,
    height: 26.201,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24",
    "data-name": "Rechteck 24",
    width: 26.202,
    height: 26.201,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_36",
    "data-name": "Rechteck 36",
    width: 57.291,
    height: 88.682,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_59",
    "data-name": "Rechteck 59",
    width: 86.977,
    height: 47.339,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_58",
    "data-name": "Rechteck 58",
    width: 86.977,
    height: 47.337,
    fill: "#09b3af"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_56",
    "data-name": "Rechteck 56",
    width: 26.711,
    height: 23.669,
    fill: "#09b3af"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bewerber",
    transform: "translate(-1395 -946.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_7",
    "data-name": "Gruppe 7",
    transform: "translate(1395 1058.475)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_6",
    "data-name": "Gruppe 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_5",
    "data-name": "Gruppe 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_4",
    "data-name": "Gruppe 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3",
    "data-name": "Gruppe 3",
    transform: "translate(0 249.813)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2",
    "data-name": "Gruppe 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1",
    "data-name": "Gruppe 1",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1",
    "data-name": "Pfad 1",
    d: "M375.809,157.882c0,6.944-84.127,12.572-187.9,12.572S0,164.826,0,157.882s84.127-12.574,187.9-12.574,187.9,5.63,187.9,12.574",
    transform: "translate(0 -145.308)",
    fill: "#d2e1fc"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_2",
    "data-name": "Pfad 2",
    d: "M102.628,59.169l2.907,3.127,1.46.925,3.366.425,4.081,2.19s-.727.865-1.076.942a4.516,4.516,0,0,1-1.895-.394l2.063,1.982,3.014,2.914a.675.675,0,0,1-.1,1.05L111.5,74.7a1.371,1.371,0,0,1-1.3-.069l-4.372-3.258-2.256-3.309L101.8,66.24,98.93,62.922Z",
    transform: "translate(71.15 42.554)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3",
    "data-name": "Pfad 3",
    d: "M112.183,90.5l5.41-3.516L102.457,67.154a4.657,4.657,0,0,1-.633-1.489L94.585,30.63c-.578-2.5-3.708-6.674-6.211-6.1l-.593.138c-3.517.531-5.441,5.4-4.805,8.541,0,0,6.325,28.551,8.08,36.277a55.376,55.376,0,0,0,3.432,4.84c5.419,7.506,17.7,16.172,17.7,16.172",
    transform: "translate(59.589 17.604)",
    fill: "#205071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M77.73,152.91h21.5v-.729a1.715,1.715,0,0,0-1.27-1.656l-7.21-2.555-5.039-1.895-.535-8.256H79.2l-.129,6.966-1.339,5.431Z",
    transform: "translate(55.903 99.12)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M77.552,149.192h22.03v-.729a1.978,1.978,0,0,0-1.329-1.827l-5.759-2.042-1.324.683H87.083l-6.136-.753-2.357-1.532L77.552,146.5Z",
    transform: "translate(55.775 102.838)",
    fill: "#231137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M63.169,153.351h21.5v-.729a1.716,1.716,0,0,0-1.27-1.656l-7.21-2.555-5.039-1.895-.535-8.256H64.637l-.129,6.966-1.339,5.431Z",
    transform: "translate(45.431 99.437)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M62.887,149.633H85.08V148.9a2.013,2.013,0,0,0-1.343-1.845l-5.759-2.042-1.3.7H72.6l-6.138-.753L64.1,143.432l-1.214,3.509Z",
    transform: "translate(45.228 103.156)",
    fill: "#2e1749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M82.778,192.84h9.358l2.909-57.909,3.768-67.659h-28l9.06,66.076Z",
    transform: "translate(50.927 48.381)",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M66.5,192.625l6.6-.289c.76-.033,1.312.134,1.379-.624L81.166,129.3l6.328-61.239H61.83l-.892,12.669,4.458,41.61-1.073,21.206.538,48.12c.012.985.012.985,1.635.964",
    transform: "translate(43.826 48.946)",
    fill: "#4e5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M78.185,26.865l9.241.266A2.147,2.147,0,0,0,89.4,25.646l.564-2.6.385-3.94.643-2.393-.306-7.576-13.393.432Z",
    transform: "translate(55.589 6.57)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    "data-name": "Pfad 11",
    d: "M76.5,25.8l7.038.567.339-7.681-5.261-.743Z",
    transform: "translate(55.021 12.903)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    d: "M86.247,103l-25.912.906s.347-7.862.832-9.751c3.45-13.487,5.887-14.2,7.7-24.225,2.727-15.062-.531-30.278,3.019-41.562a8.783,8.783,0,0,1,3.225-4.693c4.183-2.651,15.71-1.35,16.46-1.257,0,0,7.571,1.418,10.1,1.876,2.489.449,5.874,1.575,7.159,3.971,5.938,11.082-.669,22-2.287,34.87l-1.955,18.725,3.964,20.62c1.362,3.9-12.9.5-22.307.519",
    transform: "translate(43.393 15.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M94.425,16.912s1.062-6.976-3.548-9.289c-3.418-1.714-4.931-.658-5.842.007-2.118-1.272-4.3.547-5.269,2.5a4.139,4.139,0,0,0-1.936-.7,4.2,4.2,0,1,0-.746,8.357,4.137,4.137,0,0,0,1.97-.318,4.557,4.557,0,0,0,.1,2.713,5.1,5.1,0,0,0,1.613,2.29l.43-3.664c1.241-.265,2.708-.232,3.989-2.075.787-1.135.736-2.838.779-3.81,1.96,4.75,5.092,3.844,8.46,3.989",
    transform: "translate(52.688 4.814)",
    fill: "#141f42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M78.821,109.929l-19.148-2.771s.653-10.853,1.138-12.741c3.45-13.489,5.819-14.52,7.635-24.543,2.727-15.062-.765-30.284,2.785-41.567.715-2.273,3.089-4.016,4.264-4.759,2.391-1.516,7.188-1.994,13.114-1.508l.306,39.517Z",
    transform: "translate(42.917 15.72)",
    fill: "#2a6b97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M83.027,22.481c3.411.609,5.6,1.093,6.194,1.2,2.488.449,6.052,1.754,7.336,4.15,5.938,11.082.966,21.517-.653,34.387L94.635,76.11l4.143,29.556c.911,2.608-9.409,4.37-16.346,3.655L77.689,58.682Z",
    transform: "translate(55.874 16.168)",
    fill: "#2a6b97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M94.17,37.593l-19.9-2.2L67.806,65.9l21.763,1.948Z",
    transform: "translate(48.766 25.452)",
    fill: "#f36f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M75.431,48.769l3.724-1.283,1.1-.382L82.194,44.7l3.273-2.8a3.263,3.263,0,0,1,.181,1.186c-.119.327-1.564,1.645-1.6,2.835l1.65.512,1.167-1.025.509-3.043c.354-.084.915.23.918.593l.346,4.754a16.815,16.815,0,0,1-2.428,3.56l-1.365.758-2.7.081-2.085.43-3.64.533Z",
    transform: "translate(54.25 30.135)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M67.892,72.954a18.3,18.3,0,0,0,3.689-.34L89.7,67.355l-1.41-5.67-15.763.48L80.514,31.3c.524-2.405.373-7.114-1.786-8.287l-.739-.33c-3.261-.734-7.3,3.144-8.66,7.178L60.6,63.877a7.484,7.484,0,0,0,7.288,9.077",
    transform: "translate(43.46 16.251)",
    fill: "#2a6b97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M83.48,23.059l-3.793,8.792-3.07-9.743.012-.048,3.744.1,3.107.763Z",
    transform: "translate(55.103 15.866)",
    fill: "#fdc689"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M34.9,26.591,47.316,28l1.793-5.7,2.326-2.343-.9-5.355L51.611,5.2H34.9Z",
    transform: "translate(25.099 3.739)",
    fill: "#fac0b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_5",
    "data-name": "Rechteck 5",
    width: 7.453,
    height: 12.144,
    transform: "translate(59.998 27.272)",
    fill: "#fac0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M34.648,19.395l8.787.573.683,1.668H34.648Z",
    transform: "translate(24.919 13.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M32.606,163.721c.885.9,5.053.246,5.053.246l18.213-.325-.022-.806a1.9,1.9,0,0,0-1.454-1.795l-7.509-2.522-5.508-3.741-1.155-2.885-7.195.413.015,3.689-.5,5.395s-.346,1.915.062,2.331",
    transform: "translate(23.307 109.241)",
    fill: "#101b22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M54.38,11.081l-5.338-.358.636,2.118.4,1.4-.024,1-.817.652.026,1.934-1.073.382-.559-1.845-1.587.844-1.564,6.906L40.3,26.185l-4.185-.232-.115-.97-1.9-7.217-.9-8.83,6.053-5.481,5.969-.982L53.03,0l5.852,3.686L58.21,9.573Z",
    transform: "translate(23.877 0)",
    fill: "#132233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M42.331,164.739c.86.928,5.046.38,5.046.38l17.917.16v-.806a1.9,1.9,0,0,0-1.406-1.833l-7.143-2.722-5.407-3.887-1.078-2.914-7.2.222-.084,3.688-.641,5.381s-.4,1.9,0,2.331",
    transform: "translate(30.318 110.121)",
    fill: "#16242d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M36.908,210.621l7.24-.509c.834-.058,1.444.108,1.494-.727L50.2,138.609l1.551-65.362-24.61-.057.394,14.751,4.9,52.561-.218,13.637,2.864,55.472c.041,1.081.041,1.081,1.822,1.011",
    transform: "translate(19.521 52.638)",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M47.656,212.589H57.932l3.913-77.709-1.078-62.3H33.282l10.31,65.742Z",
    transform: "translate(23.936 52.2)",
    fill: "#4e5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_27",
    "data-name": "Pfad 27",
    d: "M24.382,114.852s1.895,4.7,21.21,3.64c13.258-.724,28.331-1.331,28.331-1.331s-4.327-36.186-5.2-49.7c-.43-6.619-.21-19.231-1.932-28.513C65.87,34,63.27,25.523,59.681,23.357c-3.029-1.828-8.862-3.186-8.862-3.186H41.842c-4.745.375-7.953,1.965-9.28,8.479-1.927,9.48-1.255,22.42-1.21,33.179.05,12.574-6.97,53.023-6.97,53.023",
    transform: "translate(17.535 14.507)",
    fill: "#f36f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M28.7,73.61,79.173,62.021l6.818,30.223L33.34,104.435Z",
    transform: "translate(20.639 44.605)",
    fill: "#e5e7e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_29",
    "data-name": "Pfad 29",
    d: "M48.915,73.5l1.4,4.915.418,1.449,2.18,2.5,2.14,4.358s-1.111.469-1.47.316A4.892,4.892,0,0,1,52.16,85.49l.569,3.058.3,1.136c.086.464-.8,1.485-1.276,1.465l-5.273.81a1.489,1.489,0,0,1-1.109-.885L44.01,86.322l.1-4.356L43.7,79.232l-.437-4.754Z",
    transform: "translate(31.117 52.864)",
    fill: "#fac0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_30",
    "data-name": "Pfad 30",
    d: "M42.965,75.286l.519,4.7L51.2,78.126l-.966-4.2Z",
    transform: "translate(30.9 53.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_31",
    "data-name": "Pfad 31",
    d: "M46.259,115.72s-7.076-30.734-8.1-41.247c-1.109-11.338-.127-33.017.543-44.386.2-3.462,2.9-7.807,6.665-7.908H46.2c3.787-.1,6.873,3.746,6.848,7.535L51.482,74.9l4.434,39.272Z",
    transform: "translate(27.08 15.949)",
    fill: "#f58c4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_32",
    "data-name": "Pfad 32",
    d: "M200.8,26.171,185.38,27.706l-1.726-5.5-2.244-2.259.87-5.161,2.412-9.241H200.8Z",
    transform: "translate(130.469 3.991)",
    fill: "#fac0b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_6",
    "data-name": "Rechteck 6",
    width: 7.185,
    height: 11.706,
    transform: "translate(324.087 27.213)",
    fill: "#fac0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_33",
    "data-name": "Pfad 33",
    d: "M184.268,11.219l5.146-.344-.612,2.041-.383,1.353.024.964.787.628-.026,1.864,1.035.368.538-1.778,1.53.813,1.508,6.658,4.021,1.993,4.035-.224.11-.934,1.838-6.958.868-8.512L198.852,3.87,193.1,2.922,185.569.538l-5.642,3.554.65,5.675Z",
    transform: "translate(129.402 0.387)",
    fill: "#132233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_34",
    "data-name": "Pfad 34",
    d: "M213.419,153.959a20.355,20.355,0,0,1-4.864.366l-17.273.832v-.779a1.827,1.827,0,0,1,1.355-1.766l6.887-3.3,5.213-3.746,1.038-2.809,6.944.213.081,3.555.619,5.187s.536,2.08,0,2.247",
    transform: "translate(137.57 102.67)",
    fill: "#16242d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_35",
    "data-name": "Pfad 35",
    d: "M195.543,153.959a20.355,20.355,0,0,1-4.864.366l-17.273.832v-.779a1.827,1.827,0,0,1,1.355-1.766l6.887-3.3,5.213-3.746,1.038-2.809,6.944.213.081,3.555.619,5.187s.536,2.08,0,2.247",
    transform: "translate(124.713 102.67)",
    fill: "#16242d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_36",
    "data-name": "Pfad 36",
    d: "M193.724,199.237h-9.906l-3.081-61.3L176.749,66.3h29.644L196.8,136.254Z",
    transform: "translate(127.117 47.685)",
    fill: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_37",
    "data-name": "Pfad 37",
    d: "M212.919,199.009l-6.989-.3c-.8-.036-1.389.141-1.46-.662l-7.083-66.077-6.7-64.831h27.168l.946,13.411-3.258,53.637-.327,12.861-.569,50.943c-.014,1.044-.014,1.044-1.731,1.021",
    transform: "translate(137.143 48.283)",
    fill: "#4e5152"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_38",
    "data-name": "Pfad 38",
    d: "M159.245,87.336l-3.2-7.03L186.371,73.6s2.713-37.088,7.362-47.79c.9-2.075,5.066-5.1,7.148-3.97l.82.564c3.65,2.708,3.112,6.236,1.4,12.961l-8.149,47.856a6.131,6.131,0,0,1-2.025,1.858Z",
    transform: "translate(112.228 15.53)",
    fill: "#191819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_39",
    "data-name": "Pfad 39",
    d: "M228.942,101.758s-11.177,1.154-23.7,1.09c-9.215-.046-24.9.389-28.329-1.319-.617-.308-.163-.28-.1-.968l2.7-30.722-2.7-28.771c.619-13.977,2.087-18.43,8.1-19.38l9.3-.648h10.6l9.811.595c6.055.817,9.684,1.6,10.049,14.856Z",
    transform: "translate(127.004 15.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_40",
    "data-name": "Pfad 40",
    d: "M197.821,33.5l5.035,24.7,2.679.347Z",
    transform: "translate(142.272 24.092)",
    fill: "#bd8311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_41",
    "data-name": "Pfad 41",
    d: "M196.685,21.614c0,.512-1.951.927-4.358.927s-4.36-.414-4.36-.927c0-.179.377-.318.935-.318.811,0,1.853-.609,3.425-.609a11.891,11.891,0,0,1,3.782.6c.38.138.576.156.576.327",
    transform: "translate(135.185 14.878)",
    fill: "#fac0b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_42",
    "data-name": "Pfad 42",
    d: "M195.544,109.472c.22,5.121,26.629.585,26.629.585L214.585,36.58c-.363-13.253-3.768-14.314-9.823-15.132l-10.315-.533L190.6,50.9Z",
    transform: "translate(137.079 15.042)",
    fill: "#313032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_43",
    "data-name": "Pfad 43",
    d: "M197.841,20.809h-2.634l-9.194,1.045C180,22.8,177.72,27.424,177.1,41.4l2.414,28.64-3.4,30.409c-.06.686-1.533,10.325-.915,10.633,2,.994,8.945-2.694,15.559-2.634l-1.745-49.458,3.782-24.5Z",
    transform: "translate(125.894 14.966)",
    fill: "#313032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_44",
    "data-name": "Pfad 44",
    d: "M187.225,50.119l.009.5-2.123-.089L180,48.077l-1.791.377.182,1.943-.249,2.785,3.658,2.03,3.76-.242,1.915.232.024,1.436,38.6,9.672a8.1,8.1,0,0,0,1.729.108l-.808-9.321-12.012-5.414Z",
    transform: "translate(128.118 34.577)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_45",
    "data-name": "Pfad 45",
    d: "M195.149,48.559l-6.834-.289-5.111-2.45L176.13,47.3l-2.445,7.3,1.26.167.9-1.312,3.8.624,1.308-1.656,3.909,2.17,3.76-.242,6.526.793Z",
    transform: "translate(124.913 32.954)",
    fill: "#ffc4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46",
    "data-name": "Pfad 46",
    d: "M222.3,81.172l-38.74-8.029-.132-8.161,32.464,1.826-9.765-31.714a10.515,10.515,0,0,1,4.255-12.1c4.745-2.823,7.355,1.073,8.317,4.336l12.768,44.1a7.992,7.992,0,0,1-9.167,9.748",
    transform: "translate(131.918 15.835)",
    fill: "#313032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_47",
    "data-name": "Pfad 47",
    d: "M193.23,70.057H148.082L141.53,39.278h45.146Z",
    transform: "translate(101.788 28.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_7",
    "data-name": "Rechteck 7",
    width: 69.832,
    height: 1.045,
    transform: "translate(249.871 98.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48",
    "data-name": "Pfad 48",
    d: "M147.714,54.182l8.955,1.406,1.448,4.795h5.52l1.6,3.516L154.63,62.175l-4.473-.715Z",
    transform: "translate(106.235 38.968)",
    fill: "#ffc4bf"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_27",
    "data-name": "Gruppe 27",
    transform: "translate(1553.62 979.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_26",
    "data-name": "Gruppe 26",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_25",
    "data-name": "Gruppe 25",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_24",
    "data-name": "Gruppe 24",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_23",
    "data-name": "Gruppe 23",
    transform: "translate(0 -0.001)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_22",
    "data-name": "Gruppe 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_21",
    "data-name": "Gruppe 21",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_64",
    "data-name": "Pfad 64",
    d: "M66.139,28.471H60.227a2.532,2.532,0,0,1-1.791-4.322l4.179-4.181a2.532,2.532,0,0,0,0-3.579l-5.169-5.175a2.535,2.535,0,0,0-3.582,0L49.683,15.4a2.533,2.533,0,0,1-4.324-1.788V7.694A2.531,2.531,0,0,0,42.83,5.16H35.51a2.535,2.535,0,0,0-2.531,2.534v5.915A2.529,2.529,0,0,1,28.663,15.4l-4.184-4.184a2.535,2.535,0,0,0-3.582,0l-5.172,5.175a2.527,2.527,0,0,0,0,3.579l4.181,4.181a2.532,2.532,0,0,1-1.791,4.322H12.2A2.531,2.531,0,0,0,9.673,31V38.32A2.531,2.531,0,0,0,12.2,40.851h5.912a2.532,2.532,0,0,1,1.791,4.322l-4.181,4.181a2.527,2.527,0,0,0,0,3.579L20.9,58.107a2.535,2.535,0,0,0,3.582,0l4.184-4.184a2.529,2.529,0,0,1,4.316,1.791v5.915a2.533,2.533,0,0,0,2.531,2.531h7.32a2.529,2.529,0,0,0,2.528-2.531V55.714a2.533,2.533,0,0,1,4.324-1.788l4.181,4.181a2.535,2.535,0,0,0,3.582,0l5.169-5.175a2.532,2.532,0,0,0,0-3.579l-4.179-4.181a2.53,2.53,0,0,1,1.785-4.322h5.917a2.531,2.531,0,0,0,2.528-2.531V31a2.531,2.531,0,0,0-2.528-2.531M39.169,44.523a9.862,9.862,0,1,1,9.865-9.862,9.861,9.861,0,0,1-9.865,9.862",
    transform: "translate(-9.671 9.035)",
    fill: "#09b3af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_65",
    "data-name": "Pfad 65",
    d: "M28.831,17.421l-2.789-1.2a1.3,1.3,0,0,1,.033-2.4L28.9,12.7a1.3,1.3,0,0,0,.726-1.686L28.237,7.518a1.3,1.3,0,0,0-1.686-.726L23.728,7.914a1.3,1.3,0,0,1-1.673-1.725l1.2-2.789a1.3,1.3,0,0,0-.677-1.708L19.129.209A1.3,1.3,0,0,0,17.42.888l-1.2,2.789a1.3,1.3,0,0,1-2.4-.039L12.694.819A1.3,1.3,0,0,0,11.008.093L7.517,1.48a1.3,1.3,0,0,0-.726,1.689l1.122,2.82A1.3,1.3,0,0,1,6.191,7.661L3.4,6.462A1.3,1.3,0,0,0,1.7,7.141L.208,10.591a1.3,1.3,0,0,0,.679,1.7l2.789,1.2a1.3,1.3,0,0,1-.036,2.4L.821,17.022a1.3,1.3,0,0,0-.729,1.686L1.481,22.2a1.293,1.293,0,0,0,1.686.726L5.99,21.8a1.3,1.3,0,0,1,1.673,1.722l-1.2,2.789a1.3,1.3,0,0,0,.679,1.708l3.45,1.483a1.3,1.3,0,0,0,1.708-.679l1.2-2.787a1.3,1.3,0,0,1,2.4.036l1.122,2.82a1.3,1.3,0,0,0,1.689.726L22.2,28.235a1.3,1.3,0,0,0,.729-1.689l-1.122-2.82a1.3,1.3,0,0,1,1.722-1.673l2.787,1.2a1.3,1.3,0,0,0,1.708-.679l1.486-3.45a1.3,1.3,0,0,0-.677-1.706m-9.323-.561a5.062,5.062,0,1,1-2.646-6.652,5.067,5.067,0,0,1,2.646,6.652",
    transform: "translate(55.889 0)",
    fill: "#09b3af"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_61",
    "data-name": "Gruppe 61",
    transform: "translate(1579.256 999.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_60",
    "data-name": "Gruppe 60",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_59",
    "data-name": "Gruppe 59",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_58",
    "data-name": "Gruppe 58",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_42",
    "data-name": "Gruppe 42",
    transform: "translate(62.648)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_41",
    "data-name": "Gruppe 41",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40",
    "data-name": "Gruppe 40",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_30",
    "data-name": "Gruppe 30",
    transform: "translate(31.089)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_29",
    "data-name": "Gruppe 29",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_28",
    "data-name": "Gruppe 28",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_19",
    "data-name": "Rechteck 19",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 0)",
    fill: "#09b3af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_33",
    "data-name": "Gruppe 33",
    transform: "translate(31.089 30.184)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_32",
    "data-name": "Gruppe 32",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_31",
    "data-name": "Gruppe 31",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_21",
    "data-name": "Rechteck 21",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 0)",
    fill: "#09b3af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_36",
    "data-name": "Gruppe 36",
    transform: "translate(0 30.184)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35",
    "data-name": "Gruppe 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_34",
    "data-name": "Gruppe 34",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_23",
    "data-name": "Rechteck 23",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 0)",
    fill: "#09b3af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_39",
    "data-name": "Gruppe 39",
    transform: "translate(0 62.481)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_38",
    "data-name": "Gruppe 38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_37",
    "data-name": "Gruppe 37",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_25",
    "data-name": "Rechteck 25",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 0)",
    fill: "#09b3af"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_57",
    "data-name": "Gruppe 57",
    transform: "translate(0 62.481)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_56",
    "data-name": "Gruppe 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_55",
    "data-name": "Gruppe 55",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_45",
    "data-name": "Gruppe 45",
    transform: "translate(31.089)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_44",
    "data-name": "Gruppe 44",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_43",
    "data-name": "Gruppe 43",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_28",
    "data-name": "Rechteck 28",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 0)",
    fill: "#09b3af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_48",
    "data-name": "Gruppe 48",
    transform: "translate(31.089 30.184)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_47",
    "data-name": "Gruppe 47",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_46",
    "data-name": "Gruppe 46",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_30",
    "data-name": "Rechteck 30",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 -0.001)",
    fill: "#09b3af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_51",
    "data-name": "Gruppe 51",
    transform: "translate(0 30.184)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_50",
    "data-name": "Gruppe 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_49",
    "data-name": "Gruppe 49",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_32",
    "data-name": "Rechteck 32",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 -0.001)",
    fill: "#09b3af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_54",
    "data-name": "Gruppe 54",
    transform: "translate(0 62.481)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_53",
    "data-name": "Gruppe 53"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_52",
    "data-name": "Gruppe 52",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_34",
    "data-name": "Rechteck 34",
    width: 26.202,
    height: 26.202,
    transform: "translate(0 0)",
    fill: "#09b3af"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_107",
    "data-name": "Gruppe 107",
    transform: "translate(1672.597 946.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_106",
    "data-name": "Gruppe 106",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_105",
    "data-name": "Gruppe 105",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_104",
    "data-name": "Gruppe 104",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_103",
    "data-name": "Gruppe 103",
    transform: "translate(0 -0.001)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_102",
    "data-name": "Gruppe 102",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_101",
    "data-name": "Gruppe 101",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_88",
    "data-name": "Pfad 88",
    d: "M15.743,0h50a1.715,1.715,0,0,1,1.71,1.732V31.889a1.716,1.716,0,0,1-1.71,1.722H41.2l-.034.031-14.6,13.7V33.611H15.743a1.718,1.718,0,0,1-1.715-1.722V1.732A1.717,1.717,0,0,1,15.743,0",
    transform: "translate(19.528 0)",
    fill: "#09b3af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_100",
    "data-name": "Gruppe 100",
    transform: "translate(0 23.669)",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_99",
    "data-name": "Gruppe 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_98",
    "data-name": "Gruppe 98",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_89",
    "data-name": "Pfad 89",
    d: "M25.854,9.9h-25A.858.858,0,0,0,0,10.761V25.838a.857.857,0,0,0,.856.861H13.125l.019.017,7.3,6.849V26.7h5.411a.859.859,0,0,0,.859-.861V10.761a.86.86,0,0,0-.859-.866",
    transform: "translate(0 -9.895)",
    fill: "#09b3af"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBewerber);
export default __webpack_public_path__ + "static/media/bewerber.62acfc87d5308806e2ce432bdb2ec0e0.svg";
export { ForwardRef as ReactComponent };